export default function RegisteredScreen() {
  return <div className="registered">zarejestrowales sie. slow clap</div>;
}
